import { Component, ElementRef, Input } from '@angular/core';
import { CssMediaService } from '../../lib/media.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'se-imagebutton',
    templateUrl: './se-imagebutton.component.html',
    styleUrls: ['./se-imagebutton.component.less', './se-imagebutton.component.mobile.css'],
    standalone: true,
    imports: [NgClass],
})
export class SeImageButtonComponent {
    // Data Members

    @Input()
    source: string;

    @Input()
    title: string;

    @Input()
    tooltip: string = '';

    @Input()
    textOnRight: boolean = false;
    @Input()
    small = false;
    @Input()
    smaller = false;

    constructor(
        private elementRef: ElementRef,
        public cssMediaService: CssMediaService,
    ) {}

    private _isEnabled = true;

    get isEnabled() {
        return this._isEnabled;
    }

    @Input()
    set isEnabled(isEnabled) {
        this._isEnabled = isEnabled;
        this._isOver = false;

        if (!this.isEnabled) this.elementRef.nativeElement.classList.add('disabled');
        else this.elementRef.nativeElement.classList.remove('disabled');
    }

    private _isPressed = false;

    get isPressed() {
        return this._isPressed;
    }

    private _isOver = false;

    // Constructor

    get isOver() {
        return this._isOver;
    }

    // public functions

    onMouseDown() {
        if (this.isEnabled) this._isPressed = true;
    }

    onMouseUp() {
        if (this.isEnabled) this._isPressed = false;
    }

    onMouseOver() {
        if (this.isEnabled) this._isOver = true;
    }

    onMouseOut() {
        if (this.isEnabled) this._isOver = false;
    }

    onClick(event) {
        if (!this.isEnabled) event.stopPropagation();
    }
}
